"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._ir_apps = void 0;
var IRApp_1 = require("../IRNodes/IRApp.js");
function _ir_apps() {
    var terms = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        terms[_i] = arguments[_i];
    }
    var term = new IRApp_1.IRApp(terms[0], terms[1]);
    for (var i = 2; i < terms.length; i++) {
        term = new IRApp_1.IRApp(term, terms[i]);
    }
    return term;
}
exports._ir_apps = _ir_apps;
